
export const addDays = (date, days) => {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}

export const isWeekend = (parsedDate) => {
    return (parsedDate.getDay() == 6 || parsedDate.getDay() == 0);
}

export const isValidStartDate = (requiredDate) => {
    const parsedDate = new Date(requiredDate.toString());
    const expectedDay = addDays(new Date(), 2);
    return !((parsedDate < expectedDay) ||
        isWeekend(parsedDate));
}